export default "__VITE_ASSET__zqRPTKNd__"